import React from 'react';
import {
    List, Datagrid, BooleanField, NumberField, EditButton,
    Edit, SimpleForm, BooleanInput, NumberInput, ReferenceInput, SelectInput, Create, TextField, ReferenceField
} from 'react-admin';

export const TriggerList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <NumberField source="id" />
            <NumberField source="offset_days" />
            <BooleanField source="for_host" />
            <BooleanField source="enabled" />
            <ReferenceField source="template" reference="templates">
                <TextField source="name" />
            </ReferenceField>
            <EditButton />
        </Datagrid>
    </List>
);

export const TriggerEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <NumberInput disabled source="id" />
            <NumberInput 
                source="offset_days" 
                helperText={
                    `When to send the message:
- Negative = before check-in (e.g. -2 = 2 days before arrival)
- Zero = on check-in or check-out day (see logic)
- Positive = before check-out (e.g. 2 = 2 days before departure)`
                }
            />
            <BooleanInput source="for_host" />
            <BooleanInput source="enabled" />
            <ReferenceInput source="template" reference="templates">
                <SelectInput optionText="name" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);

export const TriggerCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <NumberInput 
                source="offset_days" 
                helperText={
                    `When to send the message:
- Negative = before check-in (e.g. -2 = 2 days before arrival)
- Zero = on check-in or check-out day (see logic)
- Positive = before check-out (e.g. 2 = 2 days before departure)`
                }
            />
            <BooleanInput source="for_host" />
            <BooleanInput source="enabled" />
            <ReferenceInput source="template" reference="templates">
                <SelectInput optionText="name" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);